exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".side-form{position:fixed;top:0;left:0;bottom:0;transform:translateZ(0);transition:all .35s;will-change:transform;z-index:10000}.side-form-shadow{box-shadow:0 0 32px 0 #a9aaac80}.side-form-inner{display:flex;flex-direction:column;background-color:rgba(75,71,71,.658);width:680px;overflow:hidden;height:100%}.side-form-footer{display:flex;align-items:center;background-color:#f5f5f5;padding:10px 20px;flex:0 0 78px}.side-form-body{padding:1rem!important;overflow-y:auto;height:100%}.nb-modal-mas-tranparent{background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f7590b4","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms-varejo/varejo-modal-item-sequencia.vue
// module id = 2178
// module chunks = 0